
// --------------------------------------------------------------------------
// Pack request form - Schools varition
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;
    var schoolAddress = $(context).find('[data-binding="school-address"]');
    var $form = context.find('form');

    function init() {
        $form.on('submit', function () {
            if (!$(this).valid()) {
                var $topmostInvalidField = $('.input-validation-error:eq(0)');
                var $validationSummary = $('.validation-summary-errors');

                if ($topmostInvalidField.length !== 0) {
                    var scrollTop = $validationSummary.offset().top;
                    if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
                        window.scrollTo(0, scrollTop);
                    } else {
                        $('html, body').animate({
                            scrollTop: scrollTop
                        }, 500);
                    }
                }
            }
        });

        schoolAddress.off().on('address-updated', function () {
            var currentAddress = $('.non-edittable-address').html();
            var addressDisplay = $(this).find('.display');
            addressDisplay.empty().append(currentAddress);
            addressDisplay.find('[data-binding="edit-selected-address-button"]').remove();
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/school-form.js
// module id = 228
// module chunks = 0